<com-web-dialog
    dialogTitle="Notification{{ isClearMode ? ': Mark as Cleared' : '' }}"
    icon="{{
        isClearMode
            ? 'fa-kit fa-solid-bell-circle-xmark text-success-green'
            : 'fa-solid fa-bell'
    }}"
    [isDraggable]="true">
    <div>
        @if (formGroup) {
            <com-web-form
                (submit)="submitClear()"
                [doShowFormActions]="false"
                [formGroup]="formGroup">
                <!-- Read-only, so the payer / location / provider name can be a link -->
                <div class="flex flex-row py-2">
                    <span class="w-[145px] shrink-0 font-bold text-right pr-4">
                        Description
                    </span>
                    <div
                        class="grow min-w-0 max-h-[12rem] overflow-y-auto whitespace-pre-wrap break-words">
                        <rcp-oup-notification-description
                            [notification]="notification"
                            (linkClicked)="
                                close()
                            "></rcp-oup-notification-description>
                    </div>
                </div>
                <div class="flex flex-row py-2">
                    <span class="w-[145px] font-bold text-right pr-4">
                        Priority
                    </span>
                    <mat-radio-group
                        class="flex flex-row items-center"
                        formControlName="notificationPriority">
                        @for (option of priorityOptions; track option) {
                            <mat-radio-button
                                class="mr-4"
                                [value]="option.value"
                                >{{ option.label }}</mat-radio-button
                            >
                        }
                    </mat-radio-group>
                </div>
                <div class="flex flex-row items-center py-4">
                    <span class="font-bold w-[145px] text-right pr-4">
                        Created
                    </span>
                    <span
                        >{{ notification.createdOn | date: 'MM/dd/yyyy' }}
                    </span>
                    @if (notification?.status == 'ACTIVE') {
                        <span
                            class="pl-2 {{ getCreatedOnClass(notification) }}">
                            <span class="text-main-dark pr-1"> | </span>
                            <i
                                class="{{
                                    getCreatedOnIcon(notification)
                                }} pr-1"></i>
                            {{ getCreatedOnMessage(notification) }}
                        </span>
                    }
                </div>
                @if (notification.status === STATUSES.Inactive) {
                    <div class="flex flex-row items-center pt-4">
                        <span class="font-bold w-[145px] text-right pr-4">
                            Cleared
                        </span>
                        <span class="text-sm font-serif italic pr-0.5"
                            >By: &nbsp;</span
                        >
                        <span>{{ notification.clearedBy?.label }}</span>
                        <span class="text-sm font-serif italic pl-4 pr-0.5"
                            >On: &nbsp;</span
                        >
                        <span>{{
                            notification.clearedDate | date: 'MM/dd/yyyy'
                        }}</span>
                    </div>
                }
                @if (isClearMode) {
                    <com-web-textarea
                        sideLabel="Additional Notes"
                        controlName="message"
                        placeholder="Optional: Enter supporting notation for this Notification."
                        [tabOrder]="0"
                        [sideLabelWidth]="145"
                        [required]="true"
                        [numRows]="4"
                        [maxLength]="250"
                        [doShowMaxLength]="true"></com-web-textarea>
                }
                @if (isClearMode) {
                    <div class="flex flex-row items-center font-bold pt-2">
                        <span class="w-[145px] text-right pr-4">Note:</span>
                        <span>
                            This action will update the Notification status to
                            "Cleared"
                        </span>
                    </div>
                }
            </com-web-form>
        }
    </div>
    <div footer class="flex flex-col w-[800px]">
        <div class="flex grow w-full justify-end items-center">
            @if (!isClearMode && notification?.status == STATUSES.Active) {
                <div class="flex flex-row mr-auto">
                    <com-web-button
                        label="Clear Notification"
                        (clickEvent)="switchToClearMode()">
                    </com-web-button>
                    <com-web-button
                        label="Create To-Do"
                        (clickEvent)="createToDo(notification)">
                    </com-web-button>
                    <!--<a
            class="font-bold text-success-green cursor-pointer hover:underline underline-offset-4"
            (click)="switchToClearMode()">
            <i class="fa-kit fa-solid-bell-circle-xmark p-1"></i>Mark as
            Cleared? &#187;
          </a>
          <a
            class="font-bold cursor-pointer hover:underline underline-offset-4"
            (click)="createToDo(notification)">
            <i class="fa-kit fa-solid-bell-circle-check p-1"></i>Create
            a To-Do? &#187;
          </a>-->
                </div>
            }
            @if (isClearMode) {
                <com-web-button
                    [buttonType]="ButtonType.Cancel"
                    (clickEvent)="close()"
                    [tabOrder]="0"></com-web-button>
            }
            @if (!isClearMode && !isSubmitInProcess) {
                <com-web-button
                    [buttonStyle]="ButtonStyle.Tertiary"
                    label="Close"
                    (clickEvent)="close()"
                    [tabOrder]="0"></com-web-button>
            }
            @if (isClearMode) {
                <com-web-button
                    [buttonStyle]="ButtonStyle.Primary"
                    label="Mark as Cleared"
                    (clickEvent)="submitClear()"
                    [tabOrder]="0"
                    [loading]="isSubmitInProcess"></com-web-button>
            }
        </div>
    </div>
</com-web-dialog>
